import { signalCheckSignals } from "../../../constants";
import { getScreeningOutcomeItems } from "../../../helpers"

export const getSignalCheckData = (contentData) => {
  return {
    fakeEmailDomains: getScreeningOutcomeItems(contentData, "signalCheck.fakeEmailDomains"),
    fakeAffiliationNames: getScreeningOutcomeItems(contentData, "signalCheck.fakeAffiliationNames"),
    fakeNamesOrEmailAddresses: getScreeningOutcomeItems(contentData, "signalCheck.fakeNamesOrEmailAddresses"),
    disposableEmailDomains: getScreeningOutcomeItems(contentData, "signalCheck.disposableEmailDomains"),
    suspectArticles: getScreeningOutcomeItems(contentData, "signalCheck.suspectArticles"),
    metadataSuspects: getScreeningOutcomeItems(contentData, "signalCheck.metadataSuspects"),
    manuscriptsOfferedForSale: getScreeningOutcomeItems(contentData, "signalCheck.manuscriptsOfferedForSale"),
  };
};

export const formatScreeningOutcomeHits = (screeningOutcomes) => {
  if (!screeningOutcomes) return null;
  const labelMap = signalCheckSignals.reduce((acc, item) => {
    acc[item.value] = item.label;
    return acc;
  }, {});

  const formattedStatus = screeningOutcomes
    .map(({ type, items }) => {
      const label = labelMap[type];
      return label ? `${label}&nbsp;(x${items.length})` : null;
    })
    .join("<br>");

  return formattedStatus;
};

export const formatScreeningOutcomeHitsPlainText = (screeningOutcomes) => {
  if (!screeningOutcomes) return "";
  const labelMap = signalCheckSignals.reduce((acc, item) => {
    acc[item.value] = item.label;
    return acc;
  }, {});

  const formattedStatus = screeningOutcomes
    .map(({ type, items }) => {
      const label = labelMap[type];
      return label ? `${label} (x${items.length})` : null;
    })
    .filter(Boolean)
    .join("\n");

  return formattedStatus;
};
